import { render, staticRenderFns } from "./itemFrame2.vue?vue&type=template&id=41be5578&scoped=true"
import script from "./itemFrame2.vue?vue&type=script&lang=js"
export * from "./itemFrame2.vue?vue&type=script&lang=js"
import style0 from "./itemFrame2.vue?vue&type=style&index=0&id=41be5578&prod&lang=scss&scoped=true"
import style1 from "./itemFrame2.vue?vue&type=style&index=1&id=41be5578&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41be5578",
  null
  
)

export default component.exports